/* eslint-disable @typescript-eslint/no-unsafe-type-assertion */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import type { JSX } from 'react';

import type { TranslationKey } from '@change-corgi/core/i18n';

import { CardCarousel } from './components/CardCarousel';
import { SharingToolsCardWrapperVariant2 } from './components/SharingToolsCardWrapper/variant2';

export function Variant2(): JSX.Element {
	// This items array is temporary, and will be replaced once the actual cards are implemented
	const items = [
		{
			key: '1',
			component: (
				<SharingToolsCardWrapperVariant2
					Preview={<div>Preview</div>}
					titleKey={
						'corgi.petition.starter_dashboard_v2.sharing_tools.ready_to_share.title' as unknown as TranslationKey
					}
					descriptionKey={
						'corgi.petition.starter_dashboard_v2.sharing_tools.ready_to_share.description' as unknown as TranslationKey
					}
					primaryActionTextKey={
						'corgi.petition.starter_dashboard_v2.sharing_tools.ready_to_share.primary_action_text' as unknown as TranslationKey
					}
				/>
			),
		},
		{
			key: '2',
			component: (
				<SharingToolsCardWrapperVariant2
					Preview={<div>Preview</div>}
					titleKey={
						'corgi.petition.starter_dashboard_v2.sharing_tools.social_content.title' as unknown as TranslationKey
					}
					descriptionKey={
						'corgi.petition.starter_dashboard_v2.sharing_tools.social_content.description' as unknown as TranslationKey
					}
					primaryActionTextKey={
						'corgi.petition.starter_dashboard_v2.sharing_tools.social_content.primary_action_text' as unknown as TranslationKey
					}
				/>
			),
		},
	];
	return (
		<div className="w-full px-1 py-2 md:px-12 md:py-12">
			<CardCarousel items={items} />
		</div>
	);
}
